import LoginController from "./login.controller";

const LoginComponent = {
    template:require("./loginLocked.template.html"),
    controller:LoginController

};

export default LoginComponent;


// WEBPACK FOOTER //
// ./public/app/login/login.component.js